/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FileAttachmentFilterType = {
    All: 'ALL',
    Word: 'WORD',
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Text: 'TEXT',
    Json: 'JSON',
    Xml: 'XML',
    Image: 'IMAGE'
} as const;
export type FileAttachmentFilterType = typeof FileAttachmentFilterType[keyof typeof FileAttachmentFilterType];

